import {
  faArrowRightFromBracket,
  faExternalLink,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import UserIcon from "../../assets/images/user-icon.png";
import { getUserInfo } from "../../core/auth/auth.service";
import { signoutRequest } from "../../core/openid/openid-manager";
import { useNavigate } from "react-router-dom";
import { B2Button } from "@hdb/biome-2";
import axios from "../../core/api/axiosClientCustomAuth";
import Cookies from "universal-cookie";
interface ProfileComponentProps {
  onClickShowNavbar?: () => void;
}

function clearAllTimeouts() {
  let timers: number[] = JSON.parse(localStorage.getItem("timers") || "[]");
  for (const id of timers) {
    clearTimeout(id); // Clear the timeout
  }
  // Clear the stored IDs in localStorage
  localStorage.removeItem("timers");
}

const ProfileComponent = ({ onClickShowNavbar }: ProfileComponentProps) => {
  const navigate = useNavigate();

  const [user, setUser] = useState({} as any);
  const [provider, setProvider] = useState("");

  useEffect(() => {
    const user = getUserInfo();
    setUser(user);
    const provider = localStorage.getItem("customAuthType");

    if (!provider) {
      return;
    }

    if (provider === "AD") {
      setProvider("azure");
    } else {
      setProvider("hdbiam");
    }
  }, []);


  return (
    <div className="profile-popover">
      <div className="d-flex align-items-start">
        <img alt="user-icon" src={UserIcon} className="user-icon" />
        <div className="mt-2">
          <div className="h4 text-wrap">
            {user["profilename"]}
          </div>
          <div className="text-wrap text-muted">
            <div>{user?.rolename}</div>
            {/* <div>{user?.email} z</div> */}
          </div>

          <div className="user-actions py-4">
            <button
              type="button"
              className="d-block"
              style={{
                cursor: "pointer",
                color: "1976D2",
                fontSize: "18px",
                fontWeight: "700",
                padding: "0",
                background: "none",
                border: "none",
              }}
              onClick={() => {
                navigate("/profile");
                onClickShowNavbar?.();
              }}
            >
              <FontAwesomeIcon icon={faExternalLink} className="me-2" />
              Go to Profile
            </button>
          </div>
        </div>
      </div>
      <div className="flex justify-start">
        <B2Button
          variant="primary"
          className="logout-button"
          onClick={() => {
            clearAllTimeouts();
            onClickShowNavbar?.();
            if (provider) {
              axios.get(`/logout?provider=${provider}`).then((response) => {
                const cookies = new Cookies();
                localStorage.clear();
                sessionStorage.removeItem("currentUrl");
                cookies.remove("hdb-token", { path: "/" });
                localStorage.setItem("serverSignedOut", JSON.stringify(true));

                window.location.href = `${response.data}`;
              });
            } else {
              signoutRequest();
            }
          }}
        >
          <FontAwesomeIcon icon={faArrowRightFromBracket} className="me-2" />
          Logout{" "}
        </B2Button>
      </div>
    </div>
  );
};

export default ProfileComponent;
